module.exports = __webpack_public_path__ + "static/img/6193_phase_function_Paper_Points.7a3a15b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6193_phase_function_Paper_Points.png
// module id = hkFD
// module chunks = 0